export const cinemaData = [
    {
        id: 'showing-1',
        title: 'Wall-E',
        description: '',
        image: 'assets/img/photos/movies/wall-e.png', // Reusing an existing image
        locations: [
            {
                name: 'Oyster Creek Park',
                times: ['1st Friday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13877.868433436086!2d-95.588083!3d29.590104599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640e670102a637f%3A0xcd9c129587107e3c!2s4033%20Hwy%206%2C%20Sugar%20Land%2C%20TX%2077478!5e0!3m2!1sen!2sus!4v1775226958717!5m2!1sen!2sus" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"'
            },
            // {
            //     name: 'George Bush Park',
            //     times: ['7:00 PM'],
            //     mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96714.68291250926!2d-74.05953969406554!3d40.73061001337039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1700000000001!5m2!1sen!2sus'
            // },
            {
                name: 'McClendon Park',
                times: ['1st Saturday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1732.5512384331023!2d-95.65069799999999!3d29.716790699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640de80ca8dadfb%3A0x24627fcf311cc3f7!2s3770%20Summit%20Valley%20Dr%2C%20Houston%2C%20TX%2077082!5e0!3m2!1sen!2sus!4v1775226885038!5m2!1sen!2sus'
            }
        ]
    },
    {
        id: 'showing-2',
        title: 'Interstellar',
        description: '',
        image: 'assets/img/photos/movies/interstellar.png',
        locations: [
            {
                name: 'Oyster Creek Park',
                times: ['2nd Friday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13877.868433436086!2d-95.588083!3d29.590104599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640e670102a637f%3A0xcd9c129587107e3c!2s4033%20Hwy%206%2C%20Sugar%20Land%2C%20TX%2077478!5e0!3m2!1sen!2sus!4v1775226958717!5m2!1sen!2sus'
            },
            // {
            //     name: 'George Bush Park',
            //     times: ['7:00 PM'],
            //     mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96714.68291250926!2d-74.05953969406554!3d40.73061001337039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1700000000001!5m2!1sen!2sus'
            // },
            {
                name: 'McClendon Park',
                times: ['2nd Saturday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1732.5512384331023!2d-95.65069799999999!3d29.716790699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640de80ca8dadfb%3A0x24627fcf311cc3f7!2s3770%20Summit%20Valley%20Dr%2C%20Houston%2C%20TX%2077082!5e0!3m2!1sen!2sus!4v1775226885038!5m2!1sen!2sus'
            }
        ]
    },
    {
        id: 'showing-3',
        title: '2001: A Space Odyssey',
        description: '',
        image: 'assets/img/photos/movies/2001.png',
        locations: [
            {
                name: 'Oyster Creek Park',
                times: ['3rd Friday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13877.868433436086!2d-95.588083!3d29.590104599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640e670102a637f%3A0xcd9c129587107e3c!2s4033%20Hwy%206%2C%20Sugar%20Land%2C%20TX%2077478!5e0!3m2!1sen!2sus!4v1775226958717!5m2!1sen!2sus" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"'
            },
            // {
            //     name: 'George Bush Park',
            //     times: ['7:00 PM'],
            //     mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96714.68291250926!2d-74.05953969406554!3d40.73061001337039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1700000000001!5m2!1sen!2sus'
            // },
            {
                name: 'McClendon Park',
                times: ['3rd Saturday of the month at 7:00 PM'],
                mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1732.5512384331023!2d-95.65069799999999!3d29.716790699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640de80ca8dadfb%3A0x24627fcf311cc3f7!2s3770%20Summit%20Valley%20Dr%2C%20Houston%2C%20TX%2077082!5e0!3m2!1sen!2sus!4v1775226885038!5m2!1sen!2sus'
            }
        ]
    }
];
